import { FunctionComponent } from "react";

interface IProps {
  onClick: () => void;
  icon: string;
  className: string;
}
const ArrowButtonComponent: FunctionComponent<IProps> = (props) => {
  return (
    <button type="button" className={props.className} onClick={props.onClick}>
      <span>
        <span className="mat-symbol-round-fill" dangerouslySetInnerHTML={{ __html: props.icon }} />
      </span>
    </button>
  );
};
export default ArrowButtonComponent;
